import BasicButton from "@/components/button/BasicButton"
import { createAccountStore } from "@/stores/account"
import { Dialog, Fab, Menu } from "@mui/material"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import "./airTable.scss"
import Icon from "@/components/icon/Icon"
import { RemixIconType } from "@/types/components/icon"
import { useNativeBridge } from "@/hooks/useNativeBridge"

const manual = {
  ko: "https://help.ohcoach.com/ko",
  en: "https://help.ohcoach.com",
}

export default function AirTable() {
  const { t, i18n } = useTranslation()
  const { isWebView } = useNativeBridge()
  const { teamProfileInfo } = createAccountStore((state) => ({
    teamProfileInfo: state.teamProfileInfo,
  }))

  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const airTable = useMemo(() => {
    if (!teamProfileInfo) {
      return null
    }

    const korean = "appTxC87vkiMy4mKx/pagB9oacFyGZPGgoR"
    const english = "appTxC87vkiMy4mKx/pagykh85dOgTa15hD"

    return `https://airtable.com/embed/${i18n.language === "ko" ? korean : english}/form?prefill_Account%20Name=${
      teamProfileInfo?.airtableId
    }&hide_Account%20Name=true&prefill_Inquiry+Channel=Web+Form&hide_Inquiry+Channel=true`
  }, [i18n, teamProfileInfo])

  const openAirTable = () => {
    setIsDialogOpen(true)
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!open) {
      setAnchorEl(event.currentTarget)
    } else {
      setAnchorEl(null)
    }
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const airTableMenu = useMemo(
    () => [
      {
        value: "manual",
        text: t("helpCenter"),
        icon: "share-box",
        props: { href: manual[i18n.language as "ko" | "en"], target: "_blank" },
      },
      { value: "airtable", text: t("messageSupport"), icon: "message", func: openAirTable },
    ],
    [i18n.language],
  )

  if (!teamProfileInfo || isWebView) {
    return null
  }

  return (
    <>
      {teamProfileInfo && (
        <Fab disableRipple className="airtable-fab" onClick={handleClick} size="large">
          <Icon type="question-mark" className="fab-icon" />
          <Menu
            anchorOrigin={{ vertical: -100, horizontal: "center" }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            slotProps={{
              root: {
                className: "airtable-menu",
              },
            }}>
            {airTableMenu.map((item) =>
              item.props ? (
                <BasicButton
                  className="fab-menu-item"
                  key={item.value}
                  size="md"
                  type="ghost"
                  onClick={() => {
                    handleClose()
                    window.open(item.props.href, item.props.target)
                  }}>
                  <Icon type={item.icon as RemixIconType} />
                  {item.text}
                </BasicButton>
              ) : (
                <BasicButton
                  className="fab-menu-item"
                  key={item.value}
                  size="md"
                  type="ghost"
                  onClick={() => {
                    handleClose()
                    item.func?.()
                  }}>
                  <Icon type={item.icon as RemixIconType} />
                  {item.text}
                </BasicButton>
              ),
            )}
          </Menu>
        </Fab>
      )}
      <Dialog fullWidth open={isDialogOpen} onClose={() => setIsDialogOpen(false)}>
        <div className="airtable-dialog">
          <BasicButton
            className="close-btn"
            size="md"
            type="ghost"
            onClick={() => setIsDialogOpen(false)}>
            X
          </BasicButton>
          <iframe className="airtable-embed" src={airTable || ""} height="900" width="100%" />
        </div>
      </Dialog>
    </>
  )
}
